export default {
  title: import.meta.env.VITE_APP_NAME,//网页标题

  sideTheme: 'theme-dark',//侧边栏主题 深色主题theme-dark，浅色主题theme-light
  showSettings: false,//是否系统布局配置
  topNav: false,//是否显示顶部导航
  tagsView: true,//是否显示 tagsView
  fixedHeader: false,//是否固定头部
  sidebarLogo: true,//是否显示logo
  dynamicTitle: false,// 是否显示动态标题

  subSystemList: [],//可切换的子系统，系统返回

  //需要和app应用相匹配的参数
  app: 'scm',//该应用名称（上传文件夹路径名称有用到）
  appId: 'sys-system',//该应用匹配的AppId（上传文件夹路径名称有用到）
  appSecret: '87135AB0160F706D8B47F06BDABA6FC6',//该应用匹配的AppSecret

  activeSystemName: '中台系统',//当前访问系统名称，系统返回覆盖
  activeSystemCode: 'openauth',//该应用需要和系统类型匹配的 EnCode(当前登录的主系统界面)

  // 文件相关
  fileUrl: import.meta.env.VITE_APP_UPLOAD_URL,
  fileManageUrl: import.meta.env.VITE_APP_UPLOAD_URL + import.meta.env.VITE_APP_API, // 文件管理接口
  fileUploadUrl: import.meta.env.VITE_APP_UPLOAD_URL + import.meta.env.VITE_APP_API + 'Files/UploadFiles', // 文件上传接口 UploadFiles Upload

  hostUrl: import.meta.env.VITE_APP_BASE_URL,
  // 基础接口
  apiHostUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API,
  // 权限接口
  apiSecurityUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Security/',

  // 模块接口  
  apiCommUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Comm/', // 通用
  apiCMSUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'CMS/', // 文章
  apiAgentsUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Agents/', // 代理商
  apiAgentsGoodsUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Agents/Goods', // 代理商商品
  apiAgentsTravelsUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Agents/Travels', // 代理商门票

  apisUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Apis/', // API

  apiBillsUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Bills', // 公共业务
  apiBillsGoodUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Bills/Good', // 商品业务
  apiBillsTravelUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Bills/Travel', // 旅游业务

  apiDistributorsUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Distributors/', // 分销商
  apiMembersUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Members/', // 用户
  apiPlatformsUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Platforms/', // 平台
  apiSettingsUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Settings/', // 设置
  apiSuppliersUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Suppliers/', // 供应商
  apiShopsUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Shops/', // 平台商城

  apiWechatsUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Wechats/', // 微信
  apiLogisticsUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Exp/', // 物流
  apiTravelsUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Travels/', // 旅游

  apiActivityUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Activity/', // 活动
  apiServiceUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'Service/', // 服务商品
  apiAppUrl: import.meta.env.VITE_APP_BASE_URL + import.meta.env.VITE_APP_API + 'App/', // App通用
}
